// The workspace selector, as it appears in the Orbit top bar.
//
// One control, shown on the Hub and inside every client-scoped module. `.o-select` already
// styles a select for the ink bar — it was written for Competitive Monitoring's switcher,
// which this replaces.

import { useWorkspace } from './WorkspaceContext.jsx';
import { T } from '../styles/tokens.js';

const note = { fontSize: 12, color: T.text3 };

export default function WorkspaceSelector() {
  const { clients, clientId, setClientId, loading, total, moduleId } = useWorkspace();

  if (loading) return <span style={note}>Loading workspaces…</span>;

  // Two different empty states, and telling them apart is the whole point. "None at all" is an
  // access problem; "none here" means the clients exist but Client Management has not switched
  // any of them on for this tool — different person to ask, different thing to fix.
  if (!clients.length) {
    return (
      <span style={note}>
        {moduleId && total > 0 ? 'No client is enabled for this tool' : 'No workspace assigned'}
      </span>
    );
  }

  return (
    <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <span className="o-eyebrow" style={{ color: T.text3 }}>Workspace</span>
      <select
        className="o-select"
        aria-label="Active workspace"
        value={clientId || ''}
        onChange={e => setClientId(e.target.value)}
      >
        {clients.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
      </select>
    </label>
  );
}
